module.exports = __webpack_public_path__ + "img/52002750_L.ad6ec1e2.png";